import { GoalConfigurationTemplateContent } from "apps/web/src/views/GoalConfigurationTemplates/GoalConfigurationTemplateContent";
import { GoalConfigurationTemplateProvider } from "apps/web/src/views/GoalConfigurationTemplates/GoalConfigurationTemplateProvider";

export const GoalsTemplatePage = () => (<GoalConfigurationTemplateProvider>
    <GoalConfigurationTemplateContent />
</GoalConfigurationTemplateProvider>)
